module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Reporte Ventas")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm1": "",
      "mr-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rutas,
      "itemText": "nombre",
      "value": _vm.ruta,
      "label": "Rutas",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarruta($event)
      },
      "update:value": function($event) {
        _vm.ruta = $event
      }
    },
    model: {
      value: (_vm.ruta),
      callback: function($$v) {
        _vm.ruta = $$v
      },
      expression: "ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mr-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.usuarios,
      "itemText": "username",
      "value": _vm.usuario,
      "label": "Usuario",
      "multiple": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarusuario($event)
      },
      "update:value": function($event) {
        _vm.usuario = $event
      }
    },
    model: {
      value: (_vm.usuario),
      callback: function($$v) {
        _vm.usuario = $$v
      },
      expression: "usuario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm1": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Desde",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "hora"
    },
    model: {
      value: (_vm.horainicio),
      callback: function($$v) {
        _vm.horainicio = $$v
      },
      expression: "horainicio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechafin()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "hora"
    },
    model: {
      value: (_vm.horafin),
      callback: function($$v) {
        _vm.horafin = $$v
      },
      expression: "horafin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm1": "",
      "ml-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Extra"
    },
    model: {
      value: (_vm.extra),
      callback: function($$v) {
        _vm.extra = $$v
      },
      expression: "extra"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "ml-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comentario"
    },
    model: {
      value: (_vm.comentario),
      callback: function($$v) {
        _vm.comentario = $$v
      },
      expression: "comentario"
    }
  })], 1), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.generar
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.generartabulacion
    }
  }, [_vm._v("\n                  Tabulación "), _c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.generarcomentarios
    }
  }, [_vm._v("\n                  Comentarios "), _c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.obteneridsfactura
    }
  }, [_vm._v("\n                  Factura Electrónica "), _c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.generar('entregado')
      }
    }
  }, [_vm._v("\n                  No tocar"), _c('v-icon', [_vm._v("check")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.generarexcel
    }
  }, [_vm._v("\n                  excel"), _c('v-icon', [_vm._v("find_in_page")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.focusbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_vm._v("Re Imprimir")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confirmación Administrador")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "contraseña",
      "type": "password",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.generar('entregado'), _vm.confirmacion, _vm.nombre_tabulacion
      }
    },
    model: {
      value: (_vm.confirmacion),
      callback: function($$v) {
        _vm.confirmacion = $$v
      },
      expression: "confirmacion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre de la tabulación",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.generar('entregado'), _vm.confirmacion, _vm.nombre_tabulacion
      }
    },
    model: {
      value: (_vm.nombre_tabulacion),
      callback: function($$v) {
        _vm.nombre_tabulacion = $$v
      },
      expression: "nombre_tabulacion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false, _vm.confirmacion = '', _vm.nombre_tabulacion = ''
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1663968"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporte.vue
// module id = 450
// module chunks = 1